module.exports = __webpack_public_path__ + "static/img/JL_Portrait.1a598e0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Images/JL_Portrait.jpg
// module id = p21p
// module chunks = 1